<template>
  <div class="calico-document-list-item">
    <div class="file-info">
      <div class="document-label">
        <span class="body--medium">
          <b>{{ year }}</b>
        </span>
        <span class="body--xsmall filename">
          {{ filename }}
        </span>
      </div>
      <div
        v-if="description"
        class="description body--xsmall"
      >
        {{ description }}
      </div>
    </div>
    <span
      v-if="editable"
      style="width: fit-content;"
    >
      <button
        class="button-tertiary button-tertiary--large"
        @click="$emit('edit', filename)"
      >
        <i class="bi bi-pencil-fill" />
      </button>
    </span>
    <span style="width: fit-content;">
      <button
        class="button-tertiary button-tertiary--large"
        @click="$emit('download', filename)"
      >
        <i class="bi bi-download" />
      </button>
    </span>
    <span
      v-if="editable"
      style="width: fit-content;"
    >
      <button
        class="button-tertiary button-tertiary--large"
        @click="$emit('delete', filename)"
      >
        <i class="bi bi-trash-fill" />
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'CalicoDocumentListItem',
  props: {
    editable: {
        type: Boolean,
        default: false
    },
    year: {
        type: String,
        default: ""
    },
    filename: {
        type: String,
        default: ""
    },
    description: {
        type: String,
        default: ""
    }
  },
  emits: ['edit', 'download', 'delete'],
}
</script>

<style lang="scss">
.calico-document-list-item {
    @include inset-space($space-xsmall);
    @include inline-space($space-small);
    align-items: center;
    width: 100%;
    border-bottom: 1px solid $color-neutral-light;
    .file-info {
        @include stack-space($space-xsmall);
        flex: 1;
        .document-label {
            @include inline-space($space-xsmall);
            align-items: center;
            .filename {
                color: $color-text-secondary;
            }
        }
        .description {
            @include inset-space($space-xsmall);
            border-radius: $radius-small;
            background: $color-cyan-lightest;
        }
    }
}
</style>
